import React from 'react';
import Icon from '../../../components/AppIcon';

const BenefitsPerks = ({ benefits }) => {
  const categoryIcons = {
    'Health & Wellness': 'Heart',
    'Financial': 'IndianRupee',
    'Work-Life Balance': 'Scale',
    'Professional Development': 'GraduationCap',
    'Office Perks': 'Coffee',
    'Additional Benefits': 'Gift'
  };

  return (
    <div className="bg-card rounded-lg border border-border p-6 lg:p-8">
      <h2 className="text-2xl font-bold text-foreground mb-6">Benefits & Perks</h2>
      <div className="space-y-8">
        {Object.entries(benefits)?.map(([category, items]) => (
          <div key={category}>
            <h3 className="text-lg font-semibold text-foreground mb-4 flex items-center gap-2">
              <div className="w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center">
                <Icon name={categoryIcons?.[category]} size={18} className="text-primary" />
              </div>
              {category}
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {items?.map((benefit, index) => (
                <div
                  key={index}
                  className="flex items-start gap-3 p-4 bg-muted/50 border border-border rounded-lg hover:border-primary/50 transition-smooth"
                >
                  <div className="w-10 h-10 bg-success/10 rounded-lg flex items-center justify-center flex-shrink-0">
                    <Icon name="Check" size={18} className="text-success" />
                  </div>
                  <div>
                    <h4 className="font-semibold text-foreground mb-1">{benefit?.title}</h4>
                    <p className="text-sm text-muted-foreground">{benefit?.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BenefitsPerks;